import ImageCtaCard from './ImageCtaCard'

export default ImageCtaCard
